import { useDispatch, useSelector } from 'react-redux'
import { selectConfig } from '../../SubscriptionForm/SubscriptionFormSelectors'
import { updateConfig } from '../../SubscriptionForm/SubscriptionFormSlice'
import { useTranslation } from 'react-i18next'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import useBusinessType from '../../../../shared/hooks/useBusinessType'
import {
  BUSINESS_VERTICAL_ENERGY,
  BUSINESS_VERTICAL_INSURANCE,
  BUSINESS_VERTICAL_TELECOM,
} from '../../SubscriptionForm/Common/constants'
import { useSnackbar } from 'baseui/snackbar'

export default function useCreateContractModal() {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { enqueue } = useSnackbar()
  const { createContractSelectedType, addContractModal } = useSelector(selectConfig)
  const { isAllowedEnergyVertical, isAllowedTelecomVertical, isAllowedInsuranceVertical } = useBusinessType({})

  const handleConfirm = () => {
    dispatch({ type: subscriptionFormActionsV2.CONTRACT_CREATE_NEW, enqueue })
  }

  const handleCancel = () => {
    dispatch(updateConfig({ createContractSelectedType: null, addContractModal: false }))
  }

  const handleSelectOption = option => {
    dispatch(updateConfig({ createContractSelectedType: option }))
  }

  const toggleContractModal = () => {
    dispatch(updateConfig({ addContractModal: !addContractModal }))
  }

  return {
    handleConfirm,
    handleCancel,
    handleSelectOption,
    toggleContractModal,
    createContractSelectedType,
    isAllowedEnergyVertical,
    isAllowedTelecomVertical,
    isAllowedInsuranceVertical,
    addContractModal,
    t,
    noOptionsAllowed: !isAllowedEnergyVertical && !isAllowedTelecomVertical && !isAllowedInsuranceVertical,
    isInvalidSelectedType:
      createContractSelectedType !== BUSINESS_VERTICAL_ENERGY &&
      createContractSelectedType !== BUSINESS_VERTICAL_TELECOM &&
      createContractSelectedType !== BUSINESS_VERTICAL_INSURANCE,
  }
}
